export default {
   gGet: (state, getters, rootState) => (id) => {
     
   }
}
